/*
 * Before and after payoff (screen S7A).
 *
 * Plots both readings on the shared band bar and picks the copy that matches
 * what actually happened. Resolves from the retest submit event when the two
 * screens share a page, and from localStorage or the URL otherwise.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'bl_event_quiz';
  var BANDS = ['depleted', 'low', 'threshold', 'adequate', 'good', 'optimal'];
  var SELECTOR = '[data-sl-id="sl-section-events-before-after-v1"]';

  function readStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (_) {
      return null;
    }
  }

  function validBand(value) {
    return BANDS.indexOf(value) === -1 ? null : value;
  }

  /* localStorage first, then the URL, so a link shared across devices still
     renders the right pair. Every band is checked against the known six. */
  function resolveReadings() {
    var saved = readStored() || {};
    var first = validBand(saved.reading1);
    var second = validBand(saved.reading2);
    var at = Number.isFinite(saved.reading1At) ? saved.reading1At : null;
    var elapsed = null;

    if (saved.reading1At && saved.reading2At) {
      elapsed = Math.round((saved.reading2At - saved.reading1At) / 60);
    }

    try {
      var params = new URLSearchParams(window.location.search);
      first = validBand(params.get('r1')) || first;
      second = validBand(params.get('r2')) || second;
      var t = parseInt(params.get('t'), 10);
      if (Number.isFinite(t) && t > 0) at = at || t;
    } catch (_) {
      // Query parsing is best effort; stored state already covers the common path.
    }

    return { first: first, second: second, readingAt: at, minutes: elapsed };
  }

  function outcomeFor(first, second) {
    var a = BANDS.indexOf(first);
    var b = BANDS.indexOf(second);
    if (a === -1 || b === -1) return null;
    if (b > a) return 'improved';
    if (b < a) return 'declined';
    return 'unchanged';
  }

  /* Headlines may carry a {minutes} token. Replaced on text nodes only, so
     nothing here can inject markup. */
  function applyMinutes(root, minutes) {
    if (minutes == null) return;
    var nodes = root.querySelectorAll('[data-ba-heading], [data-ba-heading-accent]');
    Array.prototype.forEach.call(nodes, function (node) {
      Array.prototype.forEach.call(node.childNodes, function (child) {
        if (child.nodeType !== 3 || child.nodeValue.indexOf('{minutes}') === -1) return;
        child.nodeValue = child.nodeValue.replace(/\{minutes\}/g, String(minutes));
      });
    });
  }

  function placeMarker(root, key, band) {
    var marker = root.querySelector('[data-bar-marker="' + key + '"]');
    if (!marker) return null;
    var index = BANDS.indexOf(band);
    if (index === -1) {
      marker.hidden = true;
      return null;
    }
    root.style.setProperty('--sl-bar-col-' + key, String(index + 1));
    marker.hidden = false;
    return marker;
  }

  function render(root, readings) {
    if (!readings.first && !readings.second) return false;

    // Opposite sides of the bar keep both labels readable, even on the same band.
    placeMarker(root, 'before', readings.first);
    placeMarker(root, 'after', readings.second);

    var outcome = outcomeFor(readings.first, readings.second);
    if (outcome) root.dataset.outcome = outcome;

    var eyebrow = root.querySelector('[data-ba-eyebrow]');
    if (eyebrow && readings.readingAt) {
      var time = new Date(readings.readingAt * 1000)
        .toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
      eyebrow.textContent = (root.dataset.eyebrow || 'Your reading') + ' · ' + time;
    }

    applyMinutes(root, readings.minutes);
    root.hidden = false;
    return true;
  }

  function renderAll(readings) {
    var sections = document.querySelectorAll(SELECTOR);
    var shown = [];
    Array.prototype.forEach.call(sections, function (root) {
      if (render(root, readings)) shown.push(root);
    });
    return shown;
  }

  // Both readings already on hand, for example after following the SMS link.
  var initial = resolveReadings();
  if (initial.first && initial.second) renderAll(initial);

  document.addEventListener('bl:event-retest:submitted', function (event) {
    var state = event.detail && event.detail.state;
    if (!state) return;

    var props = event.detail.properties || {};
    var shown = renderAll({
      first: validBand(state.reading1),
      second: validBand(state.reading2),
      readingAt: state.reading1At || null,
      minutes: props.minutes_elapsed == null ? null : props.minutes_elapsed
    });
    if (!shown.length) return;

    // The visitor is looking at the retest card, so the payoff has to come
    // to them rather than wait further down the page.
    requestAnimationFrame(function () {
      shown[0].scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  });
})();
